import React, { FC, useRef } from 'react'
import { createPortal } from 'react-dom'
import { Carousel } from 'react-responsive-carousel'
import 'react-responsive-carousel/lib/styles/carousel.min.css'

import { IconChevronLeft, IconChevronRight, IconClose } from '@avantstay/backoffice-vectors'

import { useCreatePortalRoot, useOnClickOutside } from '../../../../hooks'
import { AssetWithDocumentProps } from '../../UploadArea.types'
import { ImagePreviewZoom } from '../ImagePreviewZoom'
import * as S from './ImagePreviewModal.styles'

export interface ImagePreviewProps {
  allFiles: AssetWithDocumentProps[]
  imageIndex: number
  enableZoom?: boolean
  onCloseImagePreview: VoidFunction
}

const ROOT_ID = 'imagePreviewId'

export const ImagePreviewModal: FC<ImagePreviewProps> = ({
  allFiles,
  imageIndex,
  enableZoom,
  onCloseImagePreview,
}) => {
  const backgroundRef = useRef(null)
  const portalRoot = useCreatePortalRoot({ rootId: ROOT_ID })

  useOnClickOutside(backgroundRef, () => onCloseImagePreview())

  if (!portalRoot) return null

  return createPortal(
    <S.CarouselContainer>
      <S.CarouselBackground ref={backgroundRef}>
        <S.CloseCarouselButton onClick={onCloseImagePreview}>
          <IconClose />
        </S.CloseCarouselButton>
        <Carousel
          showArrows={allFiles.length > 1}
          showIndicators={false}
          showStatus={false}
          selectedItem={imageIndex}
          dynamicHeight
          renderArrowPrev={(handleClick, isEnable) => (
            <S.CarouselArrowButton $isLeftAligned onClick={handleClick} disabled={!isEnable}>
              <IconChevronLeft />
            </S.CarouselArrowButton>
          )}
          renderArrowNext={(handleClick, isEnable) => (
            <S.CarouselArrowButton onClick={handleClick} disabled={!isEnable}>
              <IconChevronRight />
            </S.CarouselArrowButton>
          )}
        >
          {allFiles?.map(photo =>
            enableZoom ? (
              <ImagePreviewZoom key={`zoom-carousel-${photo.id}`} asset={photo} />
            ) : (
              <S.ImageWrapper key={`carousel-${photo.id}`}>
                <S.ImagePreview src={photo.url} fit="contain" />
              </S.ImageWrapper>
            ),
          )}
        </Carousel>
      </S.CarouselBackground>
    </S.CarouselContainer>,
    portalRoot,
  )
}
